
import {TOGGLE_BOOKMARK} from 'redux/reducers/exam/content/questions/question/action-types'

const toggleBookmark = (questionId) => ({
	type: TOGGLE_BOOKMARK,
	questionId
});

export {toggleBookmark}